export const DARK_BASE_BG_HEX = "#17191c";
